'use client';

import React from 'react';
import styles from './styles.module.scss';
import { constructClassName } from '../../utils/constructClassName';
import { UpdateColor } from './components';

export const DevSettings: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  if (process.env.APP_ENV === 'production') return null;

  return (
    <div className={constructClassName([
      styles.container,
      isOpen && styles.containerIsOpen,
    ])}
    >
      <div className={styles.innerContainer}>
        <button
          type="button"
          className={styles.button}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <span>
            Settings
          </span>
        </button>
        <div className={styles.settingsMenuContainer}>
          <p>Dev Settings</p>
          <UpdateColor />
        </div>
      </div>
    </div>
  );
};
